import React, { useEffect, useState, useRef } from 'react';
import { Menu, X, UserCircle, ChevronDown, HeartHandshake } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
const federationLinks = [{
  name: 'Президія',
  href: '/federation/presidia'
}, {
  name: 'Наглядова рада',
  href: '/federation/supervisory-board'
}, {
  name: 'Рада ветеранів',
  href: '/federation/veterans-council'
}, {
  name: 'Комісія з навчання та безпеки',
  href: '/federation/education-commission'
}, {
  name: 'Відокремлені підрозділи',
  href: '/federation/subdivisions'
}, {
  name: 'Рішення президії',
  href: '/federation/decisions'
}, {
  name: 'Документи',
  href: '/federation/documents'
}];
const disciplineLinks = [{
  name: 'Альпінізм',
  href: '/alpinism'
}, {
  name: 'Скелелазіння',
  href: '/climbing'
}, {
  name: 'Скі-альпінізм',
  href: '#'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isFederationOpen, setIsFederationOpen] = useState(false);
  const [isMobileFederationOpen, setIsMobileFederationOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const hoverTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsFederationOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleMouseEnter = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setIsFederationOpen(true);
  };
  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setIsFederationOpen(false);
    }, 150);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-white/10 ${isScrolled ? 'bg-primary shadow-md py-3' : 'bg-primary/95 backdrop-blur-sm py-4'}`} data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="flex justify-between items-center" data-id="element-188">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/76VtWMo7xiaKkHHD54aMRj/logo-removebg-preview.png" alt="ФАіСУ" className="h-9 w-9 object-contain" data-id="element-190" />
            <div className="flex flex-col" data-id="element-191">
              <span className="text-xl font-heading font-bold text-white tracking-tight leading-none" data-id="element-192">
                ФАіСУ
              </span>
              <span className="text-[10px] text-white/60 uppercase tracking-wider hidden sm:block" data-id="element-193">
                Національна Федерація
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-194">
            <Link to="/" className="text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-195">
              Головна
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-196" />
            </Link>

            {/* Federation Dropdown */}
            <div ref={dropdownRef} className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-id="element-197">
              <Link to="/federation" className="flex items-center gap-1 text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-198">
                Федерація
                <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-200 ${isFederationOpen ? 'rotate-180' : ''}`} data-id="element-199" />
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-200" />
              </Link>

              <AnimatePresence data-id="element-201">
                {isFederationOpen && <motion.div initial={{
                opacity: 0,
                y: 4
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 4
              }} transition={{
                duration: 0.15
              }} className="absolute top-full left-0 mt-3 w-64 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-50" data-id="element-202">
                    <div className="py-1" data-id="element-203">
                      {federationLinks.map(link => <Link key={link.href} to={link.href} onClick={() => setIsFederationOpen(false)} className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-primary/5 hover:text-primary transition-colors" data-id="element-204">
                          {link.name}
                        </Link>)}
                    </div>
                    <div className="border-t border-gray-100" data-id="element-205">
                      <div className="px-4 pt-2.5 pb-1" data-id="element-206">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider" data-id="element-207">
                          Дисципліни
                        </span>
                      </div>
                      {disciplineLinks.map(link => <Link key={link.href} to={link.href} onClick={() => setIsFederationOpen(false)} className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-primary/5 hover:text-primary transition-colors" data-id="element-208">
                          {link.name}
                        </Link>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            <Link to="/news" className="text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-209">
              Новини
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-210" />
            </Link>
            <Link to="/calendar" className="text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-211">
              Календар
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-212" />
            </Link>
            <Link to="/angels" className="text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-213">
              Янголи
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-214" />
            </Link>
            <Link to="/faq" className="text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-215">
              FAQ
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-216" />
            </Link>
            <Link to="/contacts" className="text-sm font-medium text-white/80 hover:text-white transition-colors relative group" data-id="element-217">
              Контакти
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-white/0 transition-all duration-300 group-hover:w-full group-hover:bg-white/50" data-id="element-218" />
            </Link>
          </nav>

          {/* Social Icons, Cabinet & Mobile Toggle */}
          <div className="flex items-center space-x-4" data-id="element-219">
            <Link to="/donate" className="hidden md:flex items-center text-rose-400 hover:text-rose-300 transition-colors" title="Підтримати федерацію" data-id="element-220">
              <HeartHandshake className="h-6 w-6" data-id="element-221" />
            </Link>
            <Link to="/login" className="hidden md:flex items-center text-white/70 hover:text-white transition-colors" title="Особистий кабінет" data-id="element-222">
              <UserCircle className="h-5 w-5" data-id="element-223" />
            </Link>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white hover:text-gray-300 transition-colors p-1" data-id="element-224">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-225" /> : <Menu className="h-6 w-6" data-id="element-226" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-227">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-primary border-t border-white/10 overflow-hidden" data-id="element-228">
            <div className="px-4 py-6 space-y-4" data-id="element-229">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-230">
                Головна
              </Link>

              {/* Federation Accordion */}
              <div data-id="element-231">
                <button onClick={() => setIsMobileFederationOpen(!isMobileFederationOpen)} className="flex items-center justify-between w-full text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-232">
                  Федерація
                  <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${isMobileFederationOpen ? 'rotate-180' : ''}`} data-id="element-233" />
                </button>
                <AnimatePresence data-id="element-234">
                  {isMobileFederationOpen && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-235">
                      <div className="pl-6 pt-2 space-y-3" data-id="element-236">
                        {federationLinks.map(link => <Link key={link.href} to={link.href} onClick={() => {
                    setIsMobileMenuOpen(false);
                    setIsMobileFederationOpen(false);
                  }} className="block text-sm text-white/70 hover:text-white transition-colors" data-id="element-237">
                            {link.name}
                          </Link>)}
                        <div className="pt-2 mt-2 border-t border-white/10" data-id="element-238">
                          <span className="text-[10px] font-bold text-white/40 uppercase tracking-wider" data-id="element-239">
                            Дисципліни
                          </span>
                        </div>
                        {disciplineLinks.map(link => <Link key={link.href} to={link.href} onClick={() => {
                    setIsMobileMenuOpen(false);
                    setIsMobileFederationOpen(false);
                  }} className="block text-sm text-white/70 hover:text-white transition-colors" data-id="element-240">
                            {link.name}
                          </Link>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>

              <Link to="/news" onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-241">
                Новини
              </Link>
              <Link to="/calendar" onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-242">
                Календар
              </Link>
              <Link to="/angels" onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-243">
                Янголи
              </Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-244">
                FAQ
              </Link>
              <Link to="/contacts" onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-245">
                Контакти
              </Link>

              <Link to="/donate" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30 pt-2" data-id="element-246">
                <HeartHandshake className="h-5 w-5 text-rose-400" data-id="element-247" />
                <span className="text-base font-medium" data-id="element-248">
                  Підтримати федерацію
                </span>
              </Link>

              <Link to="/login" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors pl-2 border-l-2 border-transparent hover:border-white/30" data-id="element-249">
                <UserCircle className="h-5 w-5" data-id="element-250" />
                <span className="text-base font-medium" data-id="element-251">Особистий кабінет</span>
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}